/**
 * @generated SignedSource<<903219b6dab5deab76b80a4c55c587e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type collectorTabConfig_viewer$data = {
  readonly collection: {
    readonly totalResults: number | null;
  } | null;
  readonly creations: {
    readonly totalResults: number | null;
  } | null;
  readonly draftItems?: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "NftItemDraftsByCreatorEdge";
    } | null> | null;
  } | null;
  readonly liveAuctions: {
    readonly totalResults: number | null;
  } | null;
  readonly liveBids: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "NftAuctionsByBidderEdge";
    } | null> | null;
  } | null;
  readonly lostBids: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "NftAuctionsByBidderEdge";
    } | null> | null;
  } | null;
  readonly tokenImports: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"importCollectionsConfig_contractImport">;
      } | null;
    } | null> | null;
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "collectorTabConfig_viewer";
};
export type collectorTabConfig_viewer$key = {
  readonly " $data"?: collectorTabConfig_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectorTabConfig_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "kind": "Literal",
  "name": "excludeOwnerCreatedItems",
  "value": true
},
v3 = {
  "kind": "Variable",
  "name": "bidderAddress",
  "variableName": "walletAddress"
},
v4 = {
  "kind": "Variable",
  "name": "username",
  "variableName": "username"
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftAuctionsByBidderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v5/*: any*/),
    "storageKey": null
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "creatorAddress",
    "variableName": "walletAddress"
  },
  (v4/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchDrafts"
    },
    {
      "kind": "RootArgument",
      "name": "username"
    },
    {
      "kind": "RootArgument",
      "name": "walletAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectorTabConfig_viewer",
  "selections": [
    {
      "alias": "creations",
      "args": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "creatorAddresses.0",
              "variableName": "walletAddress"
            }
          ],
          "kind": "ListValue",
          "name": "creatorAddresses"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "creatorProfileUsernames.0",
              "variableName": "username"
            }
          ],
          "kind": "ListValue",
          "name": "creatorProfileUsernames"
        },
        {
          "kind": "Literal",
          "name": "onlyFirstdibsContracts",
          "value": true
        }
      ],
      "concreteType": "NftItemSearchConnection",
      "kind": "LinkedField",
      "name": "nftItemSearch",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "collection",
      "args": [
        (v2/*: any*/),
        {
          "items": [
            {
              "kind": "Variable",
              "name": "ownerAddresses.0",
              "variableName": "walletAddress"
            }
          ],
          "kind": "ListValue",
          "name": "ownerAddresses"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "ownerProfileUsernames.0",
              "variableName": "username"
            }
          ],
          "kind": "ListValue",
          "name": "ownerProfileUsernames"
        }
      ],
      "concreteType": "NftItemSearchConnection",
      "kind": "LinkedField",
      "name": "nftItemSearch",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "liveAuctions",
      "args": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "auctionSellerAddresses.0",
              "variableName": "walletAddress"
            }
          ],
          "kind": "ListValue",
          "name": "auctionSellerAddresses"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "auctionSellerProfileUsernames.0",
              "variableName": "username"
            }
          ],
          "kind": "ListValue",
          "name": "auctionSellerProfileUsernames"
        },
        (v2/*: any*/)
      ],
      "concreteType": "NftItemSearchConnection",
      "kind": "LinkedField",
      "name": "nftItemSearch",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "liveBids",
      "args": [
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "status",
          "value": "BIDDER_LIVE"
        },
        (v4/*: any*/)
      ],
      "concreteType": "NftAuctionsByBidderConnection",
      "kind": "LinkedField",
      "name": "nftAuctionsByBidder",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "alias": "lostBids",
      "args": [
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "status",
          "value": "BIDDER_LOST"
        },
        (v4/*: any*/)
      ],
      "concreteType": "NftAuctionsByBidderConnection",
      "kind": "LinkedField",
      "name": "nftAuctionsByBidder",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "condition": "fetchDrafts",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "draftItems",
          "args": (v7/*: any*/),
          "concreteType": "NftItemDraftsByCreatorConnection",
          "kind": "LinkedField",
          "name": "nftItemDraftsByCreator",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftItemDraftsByCreatorEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": (v5/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": "tokenImports",
      "args": (v7/*: any*/),
      "concreteType": "NftTokenContractImportsConnection",
      "kind": "LinkedField",
      "name": "nftTokenContractImports",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NftTokenContractImportsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftTokenContractImport",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "importCollectionsConfig_contractImport",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "importStatus",
                      "storageKey": null
                    },
                    {
                      "alias": "errored",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "importStatuses",
                          "value": [
                            "NFT_ITEM_IMPORT_STATUS_ERROR"
                          ]
                        }
                      ],
                      "concreteType": "NftTokenContractImportCreatedItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                    },
                    {
                      "alias": "processing",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "importStatuses",
                          "value": [
                            "NFT_ITEM_IMPORT_STATUS_PROCESSING"
                          ]
                        }
                      ],
                      "concreteType": "NftTokenContractImportCreatedItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                    },
                    {
                      "alias": "completed",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "importStatuses",
                          "value": [
                            "NFT_ITEM_IMPORT_STATUS_COMPLETE"
                          ]
                        }
                      ],
                      "concreteType": "NftTokenContractImportCreatedItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "ae1afa98ae73b8c034ce539cc6e503e0";

export default node;
